import React from 'react';
import {connect} from 'react-redux';
import {isArray} from 'chart.js/helpers';

import {Table, TableBody, TableRow, TableCell} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import {Dispatch, Store} from 'spectra-logic-ui';

import {Product} from '../common/types';
import {fetchProduct} from '../common/fetch';

type Props = {
  item: string;
  fetchProduct: (id: string) => Promise<any>;
  products: Product[];
}

const useStyles = makeStyles({
  tableRow: {
    '& > *': {
      overflowWrap: 'break-word',
    },
  },
  key: {
    width: '30%',
  },
  value: {
    width: '70%',
  },
});

const EntitlementsSlider = ({item, fetchProduct, products}: Props) => {
  const classes = useStyles();

  React.useEffect(() => {
    if (fetchProduct !== undefined) {
      fetchProduct(item);
    }
  }, [item]);

  const product = products.find((p) => p.id === item);
  if (product === undefined) {
    return null;
  }
  if (!isArray(product.entitlements) || product.entitlements.length === 0) {
    return null;
  }
  return (
    <Table>
      <TableBody>
        {product.entitlements.map((e) => (
          <TableRow key={e.dimension} className={classes.tableRow}>
            <TableCell className={classes.key}>{e.dimension}</TableCell>
            <TableCell className={classes.value}>{e.value}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

const mapStateToProps = (state: Store) => {
  const products = state.resources['products'] || {};
  return {
    products: products.data || [],
    error: products.error,
    fetching: products.fetching,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchProduct: (id: string) => fetchProduct(id, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EntitlementsSlider);
